module.exports = __webpack_public_path__ + "static/img/banner_znbx.01d494f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/banner/banner_znbx.jpg
// module id = t5J2
// module chunks = 0